import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, SERVICES, AREAS } from "@/data/site";
import { CrestIcon } from "@/components/CrestIcon";

export default function Footer() {
  return (
    <footer className="bg-[var(--ink)] text-white/80" data-testid="site-footer">
      <div className="px-6 md:px-12 max-w-7xl mx-auto py-20 grid md:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2.5">
            <CrestIcon className="w-6 h-7 text-white/70 shrink-0" />
            <span className="flex flex-col leading-none">
              <span className="font-display text-2xl tracking-[0.15em] text-white block">STONECREST</span>
              <span className="text-[10px] tracking-[0.35em] uppercase text-[var(--oxblood)]">Exterior Specialists</span>
            </span>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-white/60">
            Premium exterior cleaning for homes across {COMPANY.region}. Roof cleaning, render softwashing, driveways, gutters, fascias & soffits.
          </p>
        </div>

        <div>
          <h4 className="text-white text-sm uppercase tracking-[0.2em] mb-5">Services</h4>
          <ul className="space-y-2.5 text-sm">
            {SERVICES.map((s) => (
              <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-white transition-colors">{s.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm uppercase tracking-[0.2em] mb-5">Areas We Cover</h4>
          <ul className="space-y-2.5 text-sm">
            {AREAS.map((a) => (
              <li key={a}><Link to={`/areas/${a.toLowerCase()}`} className="hover:text-white transition-colors">{a}</Link></li>
            ))}
            <li className="pt-2"><Link to="/blog" className="hover:text-white transition-colors">Advice & Insights</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm uppercase tracking-[0.2em] mb-5">Get In Touch</h4>
          <ul className="space-y-4 text-sm">
            <li><a href={COMPANY.phoneHref} className="flex items-center gap-3 hover:text-white transition-colors"><Phone className="w-4 h-4 text-[var(--oxblood)]" /> {COMPANY.phone}</a></li>
            <li><a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-white transition-colors"><Mail className="w-4 h-4 text-[var(--oxblood)]" /> {COMPANY.email}</a></li>
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 text-[var(--oxblood)] mt-0.5 shrink-0" /> {COMPANY.address}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="px-6 md:px-12 max-w-7xl mx-auto py-6 text-xs text-white/40 leading-relaxed space-y-1" data-testid="legal-details">
          <p className="text-white/60">StoneCrest Exteriors Specialists Ltd</p>
          <p>Registered in England and Wales · Company No. 17390567</p>
          <p>Registered Office: The Exchange, Flat 8 Percy Street, Preston, PR1 1AW</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="px-6 md:px-12 max-w-7xl mx-auto py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} {COMPANY.full}. All rights reserved.</span>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-white/70 transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-white/70 transition-colors" data-testid="footer-cookies-link">Cookie Policy</Link>
            <Link to="/admin/login" className="hover:text-white/70 transition-colors" data-testid="admin-footer-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
